export default Object.freeze({
  CircleOne: 1,
  CircleTwo: 2,
  CircleThree: 3,
  CircleFour: 4,
});
